/**
 * URL base de la API.
 * Desarrollo: http://localhost:8000 o 8001 si cambias el puerto del backend.
 * Producción (VPS): definir REACT_APP_API_URL (ej: http://tu-ip:8001 o http://tudominio.com:8001).
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
